import { Outlet } from 'react-router-dom';
import { JumboList, LinkItem } from '../components/JumboList';

const posts = [
  new LinkItem('/writings/editors', 'Emacs vs. Vim vs. programming'),
  new LinkItem('/writings/lisp1', 'Thoughts on Lisp'),
  new LinkItem('/writings/lisp2', 'Thoughts on Lisp, part 2'),
  new LinkItem('/writings/java', 'Why did I pivot to Java?'),
  new LinkItem('/writings/kde', 'Post-mortem of KDE 4-series 2008-2015'),
  new LinkItem('/writings/ubuntu1', 'Ubuntu the Broken'),
  new LinkItem('/writings/kubuntu', "Adventures with Kubuntu 15.04 PPA's"),
  new LinkItem('/writings/ubuntu2', 'Why is Ubuntu successful?'),
  new LinkItem('/writings/kiina', 'Kiinan kielen oppimisesta'),
  new LinkItem('/writings/gtk', 'Questionable Future of GTK'),
  new LinkItem('/writings/computers', "Computers Don't Sell Because..", ),
];

export function WritingList() {
  return (
    <JumboList items={posts} height='h-16' tsize='md:text-xl text-md'/>
  );
}

export function Writings() {
  return (
    <div>
      <Outlet />
    </div>
  );
}